import React from "react";

const EditIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7778 24.2222H13.0444L21.7333 15.5333L20.4667 14.2667L11.7778 22.9556V24.2222ZM10.8889 26C10.637 26 10.4259 25.9148 10.2556 25.7444C10.0852 25.5741 10 25.363 10 25.1111V22.9556C10 22.7185 10.0444 22.4926 10.1333 22.2778C10.2222 22.063 10.3481 21.8741 10.5111 21.7111L21.7333 10.5111C21.9111 10.3481 22.1074 10.2222 22.3222 10.1333C22.537 10.0444 22.763 10 23 10C23.237 10 23.4667 10.0444 23.6889 10.1333C23.9111 10.2222 24.1037 10.3556 24.2667 10.5333L25.4889 11.7778C25.6667 11.9407 25.7963 12.1333 25.8778 12.3556C25.9593 12.5778 26 12.8 26 13.0222C26 13.2593 25.9593 13.4852 25.8778 13.7C25.7963 13.9148 25.6667 14.1111 25.4889 14.2889L14.2889 25.4889C14.1259 25.6519 13.937 25.7778 13.7222 25.8667C13.5074 25.9556 13.2815 26 13.0444 26H10.8889ZM21.0889 14.9111L20.4667 14.2667L21.7333 15.5333L21.0889 14.9111Z"
        fill="#111111"
      />
    </svg>
  );
};

export default EditIcon;
